import type { ReactNode } from "react";

export type ChipSize = "sm" | "md";

const SIZE_CLASSES: Record<ChipSize, string> = {
  sm: "h-7 gap-1.5 px-2",
  md: "h-8 gap-1.5 px-2.5",
};

export interface ChipProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "className"> {
  icon?: ReactNode;

  trailingIcon?: ReactNode;

  selected?: boolean;

  size?: ChipSize;
}

export function Chip({
  icon,
  trailingIcon,
  selected = false,
  size = "md",
  children,
  disabled,
  ...rest
}: Readonly<ChipProps>) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      className={[
        "btn-focus-ring inline-flex items-center rounded-full border text-xs font-medium transition-colors",
        SIZE_CLASSES[size],
        selected
          ? "border-content-primary bg-surface-secondary text-content-primary"
          : "border-border-default bg-surface-primary text-content-secondary hover:border-border-strong hover:text-content-primary",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
      ].join(" ")}
      {...rest}
    >
      {icon}
      {children}
      {trailingIcon}
    </button>
  );
}
